import { faSearch } from "@fortawesome/pro-regular-svg-icons";
import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

import { TextField, type TextFieldProps } from "@aviary/components/TextField";
import { l } from "@aviary/locales/i18n";
import type { AviaryColorProps } from "@aviary/types/aviaryColors";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";

import { useDropdownContext } from "../../DropdownContext";
import { DropdownHeader } from "../DropdownHeader";

import * as styles from "./DropdownSearch.styles";

interface Props extends AviaryColorProps, TextFieldProps {
  onCancel: (event: ChangeEvent<HTMLInputElement>) => void;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onDebouncedChange?: (value: string) => void;
  isDebounced?: boolean;
}

const DropdownSearch = (props: Props) => {
  const { isFullWidth } = useDropdownContext();
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();

  const { value, placeholder, onCancel, onDebouncedChange, isDebounced, ...rest } = props;

  const handleCancel = () => {
    onCancel({ target: { value: "" } } as ChangeEvent<HTMLInputElement>);
  };

  const dropDownSearchStyle = [styles.dropdownSearch];

  return (
    <DropdownHeader noStyle {...rest} showDivider={false}>
      <div css={dropDownSearchStyle}>
        <TextField
          type="text"
          css={[styles.input.base, isFullWidth && styles.input.fullWidth]}
          value={value}
          isFocused={tablet.greaterThan}
          aria-label={t(l.aviary.searchBar.Search)}
          hasClearButton={!!value}
          onClearField={handleCancel}
          inputIcon={faSearch}
          placeholder={placeholder}
          onDebouncedChange={onDebouncedChange}
          isDebounced={isDebounced}
          {...rest}
        />
      </div>
    </DropdownHeader>
  );
};

export { DropdownSearch, type Props };
